export default {
    'the-classification': 'التصنيف',
    'edit-classification': 'تعديل التصنيف',
    'classification-name': 'التصنيف',
    priority: 'الأولوية',
    'add-new-classification': 'إضافة تصنيف جديد'
}